const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import i18n from '@/lib/translations/i18n';
type WorkloadSchemeSearch = {
  tab?: 'current' | 'expired';
};
export const Route = createFileRoute('/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): WorkloadSchemeSearch => ({
    tab: search.tab === 'expired' ? 'expired' : 'current'
  }),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings.capacity.capacity)
  }),
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.capacity.capacity)
    }
  }
});